<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("BUTTONS.view_notification_details") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row align-items-center">
          <div class="col-12">
            <div class="row">
              <!-- Start:: Date Input -->
              <base-input
                col="12"
                type="text"
                :placeholder="$t('TABLES.Notifications.date')"
                v-model.trim="data.date"
                disabled
              />
              <!-- Start:: Date Input -->

              <!-- Start:: Title Ar Input -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleAr')"
                v-model.trim="data.titleAr"
                disabled
              />
              <!-- End:: Title Ar Input -->

              <!-- Start:: Title En Input -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleEn')"
                v-model.trim="data.titleEn"
                disabled
              />
              <!-- End:: Title En Input -->

              <!-- Start:: Content Ar Input -->
              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentAr')"
                v-model.trim="data.contentAr"
                disabled
              />
              <!-- End:: Content Ar Input -->

              <!-- Start:: Content En Input -->
              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentEn')"
                v-model.trim="data.contentEn"
                disabled
              />
              <!-- Start:: Receiver Type Input -->

              <!-- <base-select-input
                col="12"
                :optionsList="roles"
                :placeholder="$t('TABLES.Notifications.receiverType')"
                v-model="data.role"
                disabled
              /> -->
              <!-- End:: Receiver Type Input -->
              <!-- v-if="
                  data.role && data.role.value == 'clients' && clients.length
                " -->
              <base-select-input
                class="col-12"
                :optionsList="clients"
                :placeholder="$t('TITLES.receiverType')"
                v-model="data.clients"
                required
                multiple
                disabled
                :focus="false"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateNotification",

  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      allClientsData: "ApiGetsModule/allClientsData",
      allDriversData: "ApiGetsModule/allDriversData",
    }),
    // End:: Vuex Getters

    roles() {
      return [
        {
          id: 1,
          name: this.$t("TITLES.clients"),
          value: "clients",
        },
        {
          id: 2,
          name: this.$t("STATUS.all"),
          value: "all",
        },
      ];
    },
  },

  data() {
    return {
      isWaitingRequest: false,

      data: {
        clients: null,
        providers: null,
        titleAr: null,
        titleEn: null,
        titleEn: null,
        contentAr: null,
        contentEn: null,
        date: null,
        role: { id: 2, name: this.$t("STATUS.all"), value: "all" },
      },

      clients: [],
    };
  },

  methods: {
    ...mapActions({
      getClients: "ApiGetsModule/getClients",
      getDrivers: "ApiGetsModule/getDrivers",
    }),

    async getNotificationData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `notification/show/${this.$route.params.id}`,
        });
        console.log("noti", res);

        this.data.titleAr = res.data.data.notification?.data.title?.ar;
        this.data.titleEn = res.data.data.notification?.data.title?.en;

        this.data.contentAr = res.data.data.notification?.data.body?.ar;
        this.data.contentEn = res.data.data.notification?.data.body?.en;
        this.data.date = res.data.data.notification.created_at;
        this.data.clients = res.data.data.notification.notifiable;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
  },

  created() {
    // Start:: Fire Methods
    this.getNotificationData();
    // End:: Fire Methods
  },
};
</script>
